import styled from "styled-components"

const TitleIcon = styled.div`
  border-radius: 1rem;
  background: #25beae;
  display: flex;
  align-items: center;
  padding: 0.875rem;
  height: 75px;
  width: 75px;
  flex-basis: 75px;
  margin-right: 1rem;
  flex-shrink: 0;

  & > * {
    margin: auto;
  }
`

export default TitleIcon



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/TitleIcon.js